import { usePlan } from '../store/planStore.js';
import { STORES } from '../../domain/types.js';

const NAME: Record<string, string> = { aldi: 'Aldi', tesco: 'Tesco', lidl: 'Lidl' };
const OPENS: Record<string, string> = {
  aldi: 'starts in fruit & veg',
  tesco: 'meat & fish before dairy',
  lidl: 'starts at the bakery',
};

export function ChooseStore({ onChosen }: { onChosen: () => void }): React.JSX.Element {
  const { ready, plan, setStore } = usePlan();
  if (!ready) return <p>Loading</p>;

  return (
    <section className="stores">
      <header className="plan-head">
        <h1>Where are you shopping?</h1>
        <p className="plan-count">The list re-sorts into that shop&rsquo;s walking order.</p>
      </header>
      {STORES.map((store) => (
        <button
          key={store}
          type="button"
          className="store-btn"
          aria-pressed={plan.store === store}
          onClick={() => { setStore(store); onChosen(); }}
        >
          <span className="store-name">{NAME[store]}</span>
          <span className="store-sub">{OPENS[store]}</span>
        </button>
      ))}
    </section>
  );
}
